import { useTanstackTable } from "@/modules/common/hooks/tanstack-table.hook";

import { InterestJourney, QueryInterestsSearchFilters } from "../../types";
import { useQueryInterestsPerProperty } from "./query-interests.hook";

export const useInterestsTable = ({ propertyUid }: { propertyUid: string }) => {
  const table = useTanstackTable<InterestJourney, QueryInterestsSearchFilters>({
    keyPrefix: "interests",
    defaultSortingState: [{ id: "createdAt", desc: true }],
    queryFn: ({ pagination, sorting, filters }) =>
      useQueryInterestsPerProperty({
        pagination,
        sorting,
        filters: { propertyUid, ...filters },
      }),
  });

  const handleRowClick = (row: InterestJourney) => {
    window.open(`/leads/${row.journey.uid}`, "_blank");
  };

  return { ...table, handleRowClick };
};
